/*----------------------------------------------------------------------------*\
    module.equalheight
    Equalheight in rows
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};
oy.module = oy.module || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.module.equalheight = {
    name: 'equalheight', // name of object for debugging purposes

    init: () => {
        const self = oy.module.equalheight;
        self.setupContainer();
    },

    setupContainer: ($context) => {
        const self = oy.module.equalheight;

        // Always have a working context
        const $workingContext = $context || document.body;

        // Get elements which need equalheight
        const $elements = $workingContext.querySelectorAll(`[data-module=${self.name}]`);
        const levels = self.getLevels($elements);

        // filter items and equalheight them
        for (var i = 0; i < levels.length; i++) {
            self.setupEqualheight($workingContext.querySelectorAll(`[data-module="${self.name}"][data-level="${levels[i]}"]`));
        }
    },

    setupEqualheight: ($elements) => {
        const self = oy.module.equalheight;
        if (!$elements) {
            return;
        }

        // declare some vars
        const resetValue = 0;
        let currentTallest = null;
        let currentRowStart = 0;
        let topPosition = 0;
        let $el;
        const rowElements = [];

        window.requestAnimationFrame(() => {
            // Loop over elements
            [].forEach.call($elements, ($element) => {
                $el = $element;
                $el.setAttribute('data-initialised', self.name);
                $el.style.minHeight = resetValue;
                topPosition = oy.functions.getOffset($el).top;

                if (currentRowStart !== topPosition) {
                    // Another offset another row
                    for (var $currentElement = 0; $currentElement < rowElements.length; $currentElement++) {
                        rowElements[$currentElement].style.minHeight = `${currentTallest}px`;
                    }

                    rowElements.length = 0;
                    currentRowStart = topPosition;
                    currentTallest = $el.clientHeight;
                    rowElements.push($el);
                } else {
                    // another div on the current row: Add it to the list and check if it's taller
                    rowElements.push($el);
                    currentTallest = (currentTallest < $el.clientHeight) ? ($el.clientHeight) : (currentTallest);
                }

                // the last row
                for ($currentElement = 0 ; $currentElement < rowElements.length ; $currentElement++) {
                    rowElements[$currentElement].style.minHeight = `${currentTallest}px`;
                }
            });
        });
    },

    getLevels: ($elements) => {
        const levels = [];
        [].forEach.call($elements, ($element) => {
            let level = parseFloat($element.getAttribute('data-level'));
            if (!level && typeof level !== 'undefined' || typeof level !== 'number') {
                level = 1;
                $element.setAttribute('data-level', level);
            }

            if (levels.indexOf(level) === -1) {
                levels.push(level);
            }
        });

        // sort levels
        return levels.sort();
    }
};



/*  Init all the things
\*----------------------------------------------------------------------------*/

window.addEventListener('optimizedResize', function () {
    oy.module.equalheight.setupContainer();
}, false);

window.addEventListener('load', function () {
    oy.module.equalheight.init();
}, false);
